var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import L from 'leaflet';
import { GestureHandling } from 'leaflet-gesture-handling';
import React, { useEffect, useState } from 'react';
import { Map, Marker, Popup, TileLayer, ZoomControl } from 'react-leaflet';
import HeaderTextDivider from '../header-text-divider';
import QRCode from 'qrcode.react';
import { ProjectType } from '..';
import { loadCssDesign } from '../utils/Utils';
var blueIcon = new L.Icon({
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});
var DestinationMap = function (_a) {
    var json_data = _a.json_data, getSelectedClientLanguage = _a.getSelectedClientLanguage, getTranslated = _a.getTranslated, Icon = _a.Icon, history = _a.history, projectId = _a.projectId, projectInfo = _a.projectInfo, CONSTANTS_REQ = _a.CONSTANTS_REQ, requestGet = _a.requestGet, RESPONSE = _a.RESPONSE, _b = _a.projectType, projectType = _b === void 0 ? 'kiosk' : _b, _c = _a.allWebPagesAlias, allWebPagesAlias = _c === void 0 ? {} : _c, css_id = _a.css_id, css_json = _a.css_json, snapShot = _a.snapShot;
    var setLang = getSelectedClientLanguage();
    var _d = useState(JSON.parse(json_data)), jsonData = _d[0], setJsonData = _d[1];
    var _e = useState([]), menus = _e[0], setMenus = _e[1];
    var _f = useState([]), mapPins = _f[0], setMapPins = _f[1];
    var _g = useState([]), clicked = _g[0], setClicked = _g[1];
    var _h = useState(undefined), location = _h[0], setLocation = _h[1];
    var _j = useState(undefined), mapRef = _j[0], setMapRef = _j[1];
    var _k = useState(9), zoom = _k[0], setZoom = _k[1];
    var _l = useState('destinationmap-verticalMenu destinationmap-close'), dropdownActive = _l[0], setDropdownActive = _l[1];
    var _m = useState('right'), menuIcon = _m[0], setMenuIcon = _m[1];
    var _o = useState('destinationmap-dropdown-btn destinationmap-dropdown-btn-close'), menuButton = _o[0], setMenuButton = _o[1];
    var _p = useState(false), showQRModal = _p[0], setShowQRModal = _p[1];
    var _q = useState(''), currentHref = _q[0], setCurrentHref = _q[1];
    useEffect(function () {
        getMenus();
        getMapPins();
        getLocation();
        if (projectType === ProjectType.KIOSK) {
            generateLinksForKiosk();
        }
        loadCssDesign(css_id, css_json, CONSTANTS_REQ);
    }, []);
    var generateLinksForKiosk = function () {
        var list = document.getElementsByClassName('href-link-destinationmap');
        for (var i = 0; i < list.length; i++) {
            var links = list[i].getElementsByTagName('a');
            for (var j = 0; j < links.length; j++) {
                var currentHref = links[j].href;
                setCurrentHref(currentHref);
                if (links[j].target == '_blank') {
                    links[j].removeAttribute('target');
                }
                links[j].href = window.location.href;
                links[j].style.color = 'black';
                links[j].style.cursor = 'default';
            }
        }
    };
    useEffect(function () {
        if (mapRef)
            mapRef.leafletElement.setMaxBounds(mapRef.leafletElement.getBounds());
    }, [mapRef]);
    L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
    function getMenus() {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestGet(snapShot && snapShot === true ? CONSTANTS_REQ.CLIENT.PAGETYPE_LIST_SNAPSHOT : CONSTANTS_REQ.CLIENT.PAGETYPE_LIST, {
                            max: 100,
                            active: true,
                            projectId: projectId,
                            forMap: true,
                            order: 'typeOrder',
                            orderType: 'asc',
                            search: jsonData['page_types'] != null && jsonData['page_types'].length > 0
                                ? encodeURI(JSON.stringify([
                                    { field: 'id', condition: 'IN_PARSE_LONG', value: jsonData['page_types'].toString() },
                                ]))
                                : null,
                        })];
                    case 1:
                        resp = _a.sent();
                        if (resp.status === RESPONSE.OK) {
                            if (resp.data.content != null) {
                                setMenus(resp.data.content);
                                setClicked([resp.data.content[0].id]);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function getMapPins() {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestGet(snapShot && snapShot === true ? CONSTANTS_REQ.CLIENT.MAP_PIN_LIST_SNAPSHOT : CONSTANTS_REQ.CLIENT.MAP_PIN_LIST, {
                            max: 1000,
                            active: true,
                            projectId: projectId,
                            locationId: jsonData.location.id,
                        })];
                    case 1:
                        resp = _a.sent();
                        if (resp.status === RESPONSE.OK) {
                            if (resp.data.content != null) {
                                setMapPins(resp.data.content);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function getLocation() {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(jsonData.location != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, requestGet(snapShot && snapShot === true ? CONSTANTS_REQ.CLIENT.LOCATION_EDIT + ("/" + jsonData.location.id + "/snapshot") : CONSTANTS_REQ.CLIENT.LOCATION_EDIT + ("/" + jsonData.location.id))];
                    case 1:
                        resp = _a.sent();
                        if (resp.status === RESPONSE.OK) {
                            setLocation(resp.data);
                            if (resp.data.zoom) {
                                setZoom(resp.data.zoom);
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    function showDropdown() {
        if (dropdownActive.includes('destinationmap-open')) {
            setDropdownActive('destinationmap-verticalMenu destinationmap-close');
            setMenuIcon('right');
            setMenuButton('destinationmap-dropdown-btn destinationmap-dropdown-btn-close');
        }
        else {
            setDropdownActive('destinationmap-verticalMenu destinationmap-open');
            setMenuIcon('left');
            setMenuButton('destinationmap-dropdown-btn destinationmap-dropdown-btn-open');
        }
    }
    function openLink(projectId, webPageId) {
        if (projectType === 'kiosk') {
            history.push("/" + projectId + "/" + webPageId);
        }
        else {
            if (allWebPagesAlias != {} && allWebPagesAlias[webPageId] != undefined) {
                history.push('/' + getSelectedClientLanguage() + '/' + allWebPagesAlias[webPageId]);
            }
            else {
                history.push('/' + getSelectedClientLanguage() + '/' + webPageId);
            }
        }
    }
    function menuClick(id) {
        setClicked([id]);
        showDropdown();
    }
    var Menu = function () {
        return (React.createElement("div", { className: dropdownActive }, menus != null && (React.createElement("div", null,
            React.createElement("button", { className: menuButton, onClick: showDropdown },
                React.createElement(Icon, { type: menuIcon, className: "destinationmap-dropdown-btn-icon" })),
            React.createElement("div", { className: "destinationmap-dropdown-container thin-scrollbar" }, menus.map(function (item) { return (React.createElement("a", { key: item.id, onClick: function () { return menuClick(item.id); }, className: clicked.includes(item.id) ? 'destinationmap-active' : '' },
                getTranslated(item.name, setLang),
                ' ',
                React.createElement(Icon, { type: "caret-right", style: { color: '#166aa8' } }))); }))))));
    };
    var MapPin = function (item) {
        var popupContent = {
            height: 'auto',
            width: '200px',
            marginTop: '20px',
        };
        var popupHead = {
            fontWeight: 'bold',
            fontSize: '16px',
            marginTop: '10px',
        };
        var popupText = {
            fontSize: '15px',
            marginBottom: '5px',
        };
        var link = {
            height: '60px',
            backgroundColor: '#fafafa',
            borderTop: '1px solid #f2f2f2',
            marginTop: '50px',
            textAlign: 'center',
            padding: '10px',
        };
        return (React.createElement(Marker, { key: item.id, icon: blueIcon, position: [item.latitude, item.longitude] },
            React.createElement(Popup, null,
                React.createElement("div", { style: popupContent },
                    item.imagePath && (React.createElement("img", { src: CONSTANTS_REQ.STATIC + projectId + encodeURI(item.imagePath), width: "100%", height: "150", alt: item.imagePath })),
                    React.createElement("div", { style: popupHead }, getTranslated(item.name, setLang)),
                    item.contentText != null && (React.createElement("div", { className: "destination-map-popup-text href-link-destinationmap", dangerouslySetInnerHTML: {
                            __html: getTranslated(item.contentText, setLang).replace(/(<? *script)/gi, 'illegalscript'),
                        } })),
                    item.webPage != null && item.webPage.id && (React.createElement("div", { style: link },
                        React.createElement("span", null, "VISIT:"),
                        React.createElement("a", { onClick: function () { return openLink(projectId, item.webPage.id); }, style: {
                                display: 'block',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#166aa8',
                                marginTop: '5px',
                            } },
                            "WEBSITE ",
                            React.createElement(Icon, { type: "link" }))))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: css_id, style: { marginTop: '75px' }, className: "destinationmap-container" },
            jsonData.title != null && React.createElement(HeaderTextDivider, { title: getTranslated(jsonData.title, setLang) }),
            location != null && (React.createElement(Map, { ref: function (ref) {
                    setMapRef(ref);
                }, center: [location.latitude, location.longitude], zoom: zoom, style: { height: '592px', width: '100%', marginTop: '2rem' }, zoomControl: false, touchZoom: true, gestureHandling: true, attributionControl: false, gestureHandlingOptions: {
                    text: {
                        touch: projectInfo &&
                            projectInfo.mapZoomText &&
                            getTranslated(projectInfo.mapZoomText, setLang)
                            ? getTranslated(projectInfo.mapZoomText, setLang)
                            : 'Use two fingers to move the map',
                        scroll: 'Use ctrl + scroll to zoom the map',
                        scrollMac: 'Use \u2318 + scroll to zoom the map',
                    },
                } },
                React.createElement(TileLayer, { attribution: '\u00A9 <a href="http://osm.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
                React.createElement(ZoomControl, { position: "topright" }),
                React.createElement(Menu, null),
                mapPins != null &&
                    mapPins.map(function (item) {
                        return item.categoryType != null && item.categoryType.includes(clicked[0]) && MapPin(item);
                    })))),
        React.createElement("div", { className: 'imagewithtext-modal' + " " + (showQRModal ? 'imagewithtext-showModal' : '') },
            React.createElement("div", { className: "imagewithtext-modalContent" },
                React.createElement("span", { className: "imagewithtext-closeButton", onClick: function () { return setShowQRModal(false); } }, "\u00D7"),
                React.createElement(QRCode, { size: 256, value: currentHref, style: { margin: '20px 45px 0px 45px' } })))));
};
export default DestinationMap;
//# sourceMappingURL=index.js.map